import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOverviewRoute = () => {
  const { navigation } = useNavigation()

  const baseRoute = navigation.processes.template.id

  return baseRoute.overview
}
